export default "__VITE_ASSET__46GdsUnO__"